export default __webpack_public_path__ + "static/media/SENAIT_NL_SEQ01.e93d8677.mp3";